var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHpcIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 51,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-377 -551)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.86111 1.62097 48.9827 46.1239",
    stroke: "#0098FF",
    strokeWidth: 4.71554,
    strokeMiterlimit: 10,
    fill: "none",
    transform: "matrix(1 0 0 1.06812 377 551.001)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0212 24.3351 7.86022 45.5079",
    stroke: "#0098FF",
    strokeWidth: 4.71554,
    strokeMiterlimit: 10,
    fill: "none",
    transform: "matrix(1 0 0 1.06812 377 551.001)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.4285 39.2392 19.5783 22.3281",
    stroke: "#00FFCE",
    strokeWidth: 4.71554,
    strokeMiterlimit: 10,
    fill: "none",
    transform: "matrix(1 0 0 1.06812 377 551.001)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2184 11.3114 54.2877 40.9427",
    stroke: "#00FFCE",
    strokeWidth: 4.71554,
    strokeMiterlimit: 10,
    fill: "none",
    transform: "matrix(1 0 0 1.06812 377 551.001)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.71823 6.82575 17.4387 23.5807",
    stroke: "#00FFCE",
    strokeWidth: 4.71554,
    strokeMiterlimit: 10,
    fill: "none",
    transform: "matrix(1 0 0 1.06812 377 551.001)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHpcIcon);
export default __webpack_public_path__ + "static/media/hpcIcon.735beb13232973dc48c617fc86ddb8a1.svg";
export { ForwardRef as ReactComponent };